import { Outlet } from 'react-router-dom'

import styles from './OnboardingLayout.module.css'

export function OnboardingLayout() {
  return (
    <main className={styles.page}>
      <div className={styles.shell}>
        <div className={styles.brand}>flio</div>
        <Outlet />
      </div>
    </main>
  )
}
